import { useEffect, useLayoutEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import api from '../../utils/api';

const ThemeSync = ({ user }) => {
    const { theme, setTheme } = useTheme();

    // 1. Sync reconciled profile theme -> app theme before paint (avoids light flash)
    useLayoutEffect(() => {
        const t = user?.preferences?.theme;
        if (t !== 'light' && t !== 'dark') return;
        setTheme((cur) => (t === cur ? cur : t));
    }, [user?._id, user?.id, user?.preferences?.theme, setTheme]);

    // 2. Sync Local Theme -> User Preference (On Change)
    useEffect(() => {
        if (!user) return;

        // Debounce or check logic to avoid excessive API calls
        // We only save if it differs from what we think the user has
        if (user.preferences?.theme !== theme) {
            const saveTheme = async () => {
                try {
                    await api.put('/users/profile/preferences', { theme });
                } catch (err) {
                    console.error('Failed to save theme preference:', err);
                }
            };

            // Small timeout to prevent clashing with the initial load
            const timer = setTimeout(saveTheme, 1000);
            return () => clearTimeout(timer);
        }
    }, [theme, user]);

    return null;
};

export default ThemeSync;
